<template>
  <div class="dialog-content pl-3 pt-3" v-if="this.currentQuotation != null">
    <v-row>
      <div>
        <table style="min-width: 100%; font-size: 12px">
          <tr>
            <td>
              <table
                style="
                  text-align: center;
                  min-width: 100%;
                  font-size: 12px;
                  min-height: 55px;
                  border-collapse: collapse;
                "
              >
                <tr
                  style="
                    background-color: #f2f2f2;
                    font-weight: bold;
                    min-width: 100%;
                  "
                >
                  <td style="width: 33%; text-align: left;">
                    <span>
                      <img loading="lazy"
                        style="max-width: 30%; margin-left: 10px"
                        src="@/assets/Tagline_todo preto.png"
                      />
                    </span>
                  </td>
                  <td style="width: 33%">
                    <span style="text-align: center; font-size: 18px"
                      >Lockton Brasil</span
                    ><br />
                    <span style="text-align: center; font-size: 16px"
                      >Cotação de Seguro Cafezal</span
                    ><br />
                    <span style="text-align: center; font-size: 14px"
                      >Proteção e Segurança para o Produtor Rural</span
                    >
                  </td>
                  <td style="width: 33%; text-align: right">
                    <span>
                      <img loading="lazy"
                        style="max-width: 30%; margin-right: 10px; max-height: 90px; margin-top: 6px"
                        :src="getLogoGrupoEconomico()"
                      />
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table style="font-size: 12px; min-width: 100%">
                <tr>
                  <td
                    colspan="6"
                    style="
                      background-color: black;
                      color: white;
                      min-width: 100%;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px">DADOS DO PROPONENTE</span>
                  </td>
                </tr>
                <tr style="text-align: left">
                  <th colspan="2">Nome</th>
                  <th>CPF/CNPJ</th>
                  <th>Telefone</th>
                  <th>Município do Risco</th>
                  <th>UF</th>
                </tr>
                <tr>
                  <td colspan="2" style="background-color: #f2f2f2">
                    {{ this.currentQuotation.segurado.nome }}
                  </td>
                  <td style="background-color: #f2f2f2">
                    {{ this.currentQuotation.segurado.numero_documento }}
                  </td>
                  <td style="background-color: #f2f2f2">
                    {{ this.currentQuotation.segurado.celular }}
                  </td>
                  <td style="background-color: #f2f2f2">
                    {{ this.currentQuotation.area_risco.cidade }}
                  </td>
                  <td style="background-color: #f2f2f2">
                    {{ this.currentQuotation.area_risco.uf.id }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table style="font-size: 12px; min-width: 100%">
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-width: 100%;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px">
                      DADOS DO RISCO
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr style="padding: 5px;">
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                "
              >
                <tr style="text-align: left; font-size: 12px;">
                  <td colspan="7"></td>
                  <td
                    colspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Espaçamento (m)
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Número de Plantas por <br />
                    Hectare
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    POS - Normal
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    POS - Reduzida
                  </td>
                </tr>
                <tr style="text-align: left; font-size: 12px;">
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Item
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Talhão
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Espécie
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Idade(anos)
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Variedade
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Sistema de cultivo
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Área Plantada(ha)
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Entre Plantas
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Entre Linhas
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in this.currentQuotation.itens_cafezal"
                  :key="item.id"
                >
                  <td style="text-align: center; border: 1px solid black">
                    {{ currentQuotation.itens_cafezal.indexOf(item) + 1 }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ "Área " + (index + 1) + " - " + item.nome }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.especie_cafe.name }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.idade }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.variedade_cafe.name }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.sistema_cultivo_cafe.name }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ asNumberString(item.area_plantada) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ asNumberString(item.espacamento_plantas) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ asNumberString(item.espacamento_linhas) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.planta_hectare }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.percentual_pos_normal }}%
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.percentual_pos_reduzida }}%
                  </td>
                </tr>
                <tr>
                  <br />
                </tr>
                <tr>
                  <td colspan="4"></td>
                  <td
                    colspan="3"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border-bottom: 1px solid black;
                    "
                  >
                    Área Plantada Total (ha):
                    <span> {{ asNumberString(areaPlantadaTotal) }} </span>
                  </td>
                  <td></td>
                  <td
                    colspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border-bottom: 1px solid black;
                    "
                  >
                    Total de Plantas:
                    <span> {{ asIntergerString(getTotalPlantas) }} </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="12" style="min-width: 100%; font-size: 12px; padding-top: 10px;">
                    <span
                      >*Para calcular o valor da planta, basta dividir a
                      indenização por hectare pelo número de plantas por
                      hectare.</span
                    >
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td v-if="this.isTableView">
              <table style="font-size: 12px; min-width: 100%">
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-width: 100%;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px; min-width: 100%">
                      DADOS DA COTAÇÃO - SEGURO CAFEZAL
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td v-if="this.isTableView">
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                "
              >
                <tr style="text-align: left; font-size: 12px">
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Id
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Seguradora
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Área Segurada (ha)
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Valor da Planta
                  </td>
                  <td
                    colspan="4"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Cobertura
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    POS
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Prêmio Total
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Subvenção <br />
                    Federal
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Subvenção <br />
                    Estadual
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Prêmio Segurado
                  </td>
                  <td
                    rowspan="2"
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Investimento
                  </td>
                </tr>
                <tr>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Granizo
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Granizo e Geada
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Perda Produção <br />Futura
                  </td>
                  <td
                    style="
                      text-align: center;
                      background-color: #f2f2f2;
                      border: 1px solid black;
                    "
                  >
                    Tratamento Fitossanitário
                  </td>
                </tr>
                <tr
                  v-for="item in getCustos()"
                  :key="item.id"
                >
                <td style="text-align: center; border: 1px solid black">
                  {{ "1." + (getCustos().indexOf(item) + 1) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.seguradora.nome }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.area_segurada }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    R$ {{ asNumberString(item.valor_planta) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    <p v-if="item.granizo > 0">R$ </p>
                    {{ item.granizo > 0 ? asNumberString(item.granizo) : "-" }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    <p v-if="item.granizo_geada > 0">R$ </p>
                    {{
                      item.granizo_geada > 0
                        ? asNumberString(item.granizo_geada)
                        : "-"
                    }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    R$ {{ asNumberString(item.perda_producao_futura) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    R$ {{ asNumberString(item.tratamento_fitossanitario) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    {{ item.tipo_pos.name }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    R$ {{ asNumberString(item.premio_total) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    R$ {{ asNumberString(item.subvencao_federal) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    R$ {{ asNumberString(item.subvencao_estadual) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    R$ {{ asNumberString(item.premio_segurado) }}
                  </td>
                  <td style="text-align: center; border: 1px solid black">
                    R$ {{ asNumberString(item.investimento) }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <table v-if="!this.isTableView">
            <tr>
              <td>
                <table style="font-size: 12px; min-width: 100%">
                  <tr>
                    <td
                      style="
                        background-color: black;
                        color: white;
                        min-width: 100%;
                        min-height: 15px;
                        text-align: left;
                      "
                    >
                      <span style="margin-left: 5px">
                        DADOS DA COTAÇÃO - SEGURO CAFEZAL
                      </span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr class="containerCardsCafezal">
              <td
                class="container_cardCafezal ml-5"
                v-for="(item, index) in getCustosCard"
                :key="item.id"
              >
                <QuotationCostsCardCafezal
                  ref="cardCafezal"
                  :item="item"
                  :index="getCardIndex(index)"
                  class="card-wrapperCafezal"
                  :showButton="false"
                />
              </td>
            </tr>
          </table>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px">DETALHE DAS COBERTURAS</span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px;">
                    <h4>Cobertura Básica</h4>
                    <span>
                      Este seguro tem por objetivo proteger os pés-de-café da
                      lavoura segurada contra a ocorrência dos eventos
                      climáticos cobertos <strong>(Granizo & Geada)</strong>,
                      identificando os danos a partir da poda a ser realizada
                      para sua recuperação.
                    </span>
                    <h4>
                      <strong>Adicional Perda de Produção Futura (PPF):</strong>
                    </h4>
                    <span>
                      Proteção aos pés-de-café da lavoura segurada contra a
                      ocorrência dos eventos climáticos cobertos (Granizo e
                      Geada), identificando os danos a partir da poda a ser
                      realizada para sua recuperação.
                    </span>
                    <ul>
                      <li>
                        <span style="color: #c00000; font-weight: bold">
                          Funcionamento (PPF):
                        </span>
                        <span>
                          Indenização ao produtor em caso de sinistro
                          indenizável ocorrido na cobertura básica de 75% da
                          Básica
                        </span>
                      </li>
                    </ul>
                    <h4>
                      <strong
                        >Cobertura Adicional Tratamento Fitossanitário:</strong
                      >
                    </h4>
                    <span>
                      Na ocorrência de evento coberto (Somente Granizo), custear
                      parte dos gastos do produtor com a aplicação de fungicida
                      para tratamento fitossanitário da lavoura segurada.
                    </span>
                    <ul>
                      <li>
                        <span style="color: #c00000; font-weight: bold">
                          Funcionamento tratamento Fitossanitário:
                        </span>
                        <span>
                          O Produtor irá receber até R$550,00 por hectare
                          afetado por granizo, nos casos em que não há
                          necessidade de poda do cafeeiro e há recomendação do
                          perito pelo tratamento fitossanitário.
                        </span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px;"
                      >PORCENTAGEM DE INDENIZAÇÃO</span
                    >
                  </td>
                </tr>
                <tr>
                  <td style="display:flex; flex-direction: row; padding: 5px;">
                    <table
                      style="font-size: 12px; border-collapse: collapse; min-width: 60%;"
                      width="60%"
                    >
                      <tr>
                        <td
                          rowspan="2"
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Idade Cafezal
                        </td>
                        <td
                          colspan="4"
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Tipo de Poda
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Arranquio
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Recepa
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Esqueletamento /<br />
                          Decote Baixo
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Decote
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Inferior ou igual a 2 anos
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          100%
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          50%
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          -
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          -
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Superior a 2 anos
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          100%
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          75%
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          50%
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          -
                        </td>
                      </tr>
                    </table>
                    <div style="padding: 8px;" width="40%">
                      <h4>Tipos de Poda:</h4>
                      <ul>
                        <li>
                          <span><strong>Arraquio: </strong></span>
                          retirada total das plantas mortas do solo;
                        </li>
                        <li>
                          <span><strong>Recepa: </strong></span>
                          corte da planta a uma altura de aproximadamente 40cm ou
                          60cm do solo;
                        </li>
                        <li>
                          <span><strong>Esqueletamento / Paliamento: </strong></span>
                          desgalhamento lateral da planta, deixando-se o tronco ou
                          haste principal com os ramos laterais apenas com 30 ou
                          50cm de comprimento;
                        </li>
                        <li>
                          <span><strong>Decote Baixo: </strong></span>
                          corte da planta a uma altura média entre 1,2 e 1,7m acima
                          do solo;
                        </li>
                        <li>
                          <span><strong>Decote: </strong></span>
                          corte da planta a uma altura acima 1,70m do solo.
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                <tr style="border: 1px solid black"></tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px;">RACIONAL DE INDENIZAÇÃO SEGURO CAFEZAL</span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px;">
                    <table
                      style="
                        font-size: 12px;
                        min-width: 100%;
                        border-collapse: collapse;
                        background-color: #f2f2f2;
                      "
                    >
                      <tr style="text-align: left; font-size: 12px">
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Talhão
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Área Atingida(ha)
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Idade<br />
                          Cafezal<br />
                          (Anos)
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Necessidade<br />
                          de Poda
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Tipo de Poda
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Nº de Plantas
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Valor por Planta (R$)
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          % de Indenização<br />
                          (Poda e Idade<br />
                          Cafezal)
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Prejuízo<br />
                          Cobertura básica
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          POS (%)
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Indenização<br />
                          Básica
                        </td>
                        <td
                          style="
                            text-align: center;
                            background-color: #f2f2f2;
                            border: 1px solid black;
                          "
                        >
                          Indenização Perda Produção<br />
                          Futura - R$ (75% da Básica)
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center; border: 1px solid black">
                          {{ "Café da Casa" }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          {{ asNumberString(1.6) }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          {{ "15" }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          {{ "sim" }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          {{ "Recepa" }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          {{ asNumberString(7143) }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          R$ {{ asNumberString(2.82) }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          {{ "75%" }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          R$ {{ asNumberString(15120.0) }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          {{ "5%" }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          R$ {{ asNumberString(14364.0) }}
                        </td>
                        <td style="text-align: center; border: 1px solid black">
                          R$ {{ asNumberString(10773.0) }}
                        </td>
                      </tr>
                      <tr style="align-items: right">
                        <td
                          colspan="9"
                          style="
                            text-align: center;
                          "
                        ></td>
                        <td
                          style="
                            text-align: right;
                            border-bottom: 2px solid black;
                          "
                        >
                          Indenização por Cobertura:
                        </td>
                        <td
                          style="
                            text-align: center;
                            border-bottom: 2px solid black;
                          "
                        >
                          R$ {{ asNumberString(14364.00) }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            border-bottom: 2px solid black;
                          "
                        >
                          R$ {{ asNumberString(10773.00) }}
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center; border: 2px solid black; border-right: 0;">
                          Indenização Trat.Fitossanitário:
                        </td>
                        <td style="text-align: center; border: 2px solid black; border-left: 0;">
                          R$ {{ asNumberString(640.00) }}
                        </td>
                        <td
                        colspan="7"
                          style="
                            text-align: center;
                          "
                        >
                        </td>
                        <td style="text-align: right; border-bottom: 2px solid black">
                          Indenização Total:
                        </td>
                        <td style="text-align: center; border-bottom: 2px solid black" colspan="2">
                          R$ {{ asNumberString(25137.00) }}
                        </td>
                      </tr>
                    </table>
                    <ul style="margin-top: 4px;">
                      <li>
                        Exemplo de indenização considerando à necessidade de
                        realizar <strong>recepa</strong> no cafezal do talhão:
                        <strong>Café da Casa</strong>
                      </li>
                      <li>
                        Observação: Em caso de sinistro no produto Cafezal a
                        apuração será por talhão.
                      </li>
                    </ul>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr v-if="this.currentQuotation.itens_cafezal.length > 0">
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    v-html="formatText(currentQuotation.informacoes_adicionais)"
                  ></td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px;">VIGÊNCIA, CARÊNCIAS & RISCOS EXCLUÍDOS</span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px;">
                    <span style="color: #c00000; font-weight: bold"
                      >Início de vigência:
                    </span>
                    <span>
                      O seguro tem início a partir da data de transmissão da
                      proposta de seguro no sistema da Seguradora.
                    </span>
                    <br />
                    <span style="color: #c00000; font-weight: bold"
                      >Fim de Vigência:
                    </span>
                    <span>
                      Seguro com vigência anual, portanto o fim de vigência é
                      365 dias após o início.
                    </span>
                    <br />
                    <span style="color: #c00000; font-weight: bold"
                      >Carência:
                    </span>
                    <span>
                      Contada a partir do início de vigência do seguro:
                    </span>
                    <ul>
                      <li>
                        <span>
                          <strong>Granizo: </strong>
                        </span>
                        <span> 6 dias; </span>
                      </li>
                      <li>
                        <span>
                          <strong>Geada: </strong>
                        </span>
                        <span> 15 dias; </span>
                      </li>
                    </ul>
                    <span style="color: #c00000; font-weight: bold">
                      Riscos Excluídos:
                    </span>
                    <span>
                      Ficam excluídas as perdas causadas por: pragas, doenças,
                      perda de qualidade, variação de preço e todos os demais
                      previstos nas Condições Gerais do produto
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px;">SUSEP – SUPERINTENDÊNCIA DE SEGUROS PRIVADOS</span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px;">
                    <p>
                      A SUSEP é o órgão responsável pela regulamentação e
                      fiscalização das operações das seguradoras, sujeitas às
                      leis e regulamentos no Brasil, inclusive referentes à
                      solvência. Em atendimento as disposições contidas na
                      Resolução CNSP no 382/2020, a comissão de corretagem para
                      esta colocação {{ getComissao }}. Havendo
                      interesse em obter mais informações sobre alguma
                      seguradora em particular, incluindo informação sobre suas
                      finanças e solvência, por favor, consulte diretamente a
                      SUSEP
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px;">SUBVENÇÃO FEDERAL</span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px;">
                    <p>
                      <span style="color: #c00000; font-weight: bold; margin-left: 5px;">
                        Subvenção Federal/Estadual:
                      </span>
                      Esta proposta de seguro poderá ser submetida ao Ministério
                      da Agricultura, Pecuária e Abastecimento - MAPA para
                      verificação quanto à concessão de subvenção ao prêmio de
                      seguro rural do Governo Federal, conforme os critérios
                      exigidos pelo Programa, que devem ser atendidos
                      integralmente pelo Proponente/Segurado. Caso a proposta
                      não se enquadre nas regras vigentes do programa ou o MAPA
                      não conceda, ou conceda parcialmente, o subsídio, o
                      pagamento correspondente ao valor não obtido da subvenção
                      federal ao prêmio líquido do seguro será de inteira
                      responsabilidade do Proponente/Segurado. Nesse caso, o
                      Proponente/Segurado deverá efetuar o pagamento da parcela
                      correspondente à subvenção, no vencimento previsto em
                      boleto a ser enviado pela seguradora, restando acordado
                      desde já que o não pagamento desta parcela determinará a
                      redução da vigência da apólice.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px">ASSISTÊNCIAS</span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px;">
                    <p>
                      O Seguro Cafezal inclui Assistência, que poderá ser
                      utilizada dentro da vigência dessa apólice, para os
                      serviços listados:
                    </p>
                    <ul>
                      <li>Telemedicina;</li>
                      <li>
                        Programa de Benefícios (Desconto em medicamentos e em
                        produtos de higiene, protetor solar, vitaminas e
                        suplementos);
                      </li>
                      <li>Vantagens em rede de saúde familiar;</li>
                      <li>Funeral Individual</li>
                      <li>
                        Traslado Funerário (Brasil: Até R$ 10.000,00 (dez mil
                        reais), Exterior: US$ 20.000,00* (vinte mil dólares).
                      </li>
                      <li>
                        Assistência Funeral (A somatória dos itens descritos
                        acima não pode ultrapassar o limite de até R$ 3.000,00
                        (Três mil reais) durante a vigência do Regulamento de
                        Assistência.)
                      </li>
                      <li>
                        Transporte de Responsável para Liberação do Corpo (O
                        meio de transporte fica a critério do Canal de
                        Atendimento de Assistência;
                      </li>
                      <li>
                        Cartão Alimentação Falecimento: R$250,00 (duzentos e
                        cinquenta) reais, limitado a 03 (três) meses durante o
                        período de vigência do Regulamento de Assistência.
                      </li>
                      <li>Marketing Digital</li>
                      <li>Assessoria Contábil</li>
                      <li>Assessoria Financeira</li>
                      <li>Assistência Legal</li>
                    </ul>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    style="
                      background-color: black;
                      color: white;
                      min-height: 15px;
                      text-align: left;
                    "
                  >
                    <span style="margin-left: 5px">
                      DIVULGAÇÃO E CONFIRMAÇÃO DE INFORMAÇÕES
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="min-width: 100%; padding: 5px">
                    <p>
                      <span>
                        Essa cotação é válida a partir da data de sua emissão,
                        enquanto o produto estiver vigente e/ou disponível para
                        venda pela seguradora. Confirme se as condições estão
                        válidas com a Cooxupé/Lockton no ato do aceite da cotação.
                      </span>
                      <br />
                      <span>
                        Esta proposta foi produzida com base nas informações
                        disponibilizadas por você, e por esta razão, a Lockton
                        não assumirá qualquer responsabilidade decorrente da
                        imprecisão dos dados recebidos ou as recomendações
                        baseadas na informação fornecida.
                      </span>
                      <br />
                      <span>
                        Este documento não oferece qualquer recomendação legal,
                        contábil ou tributária.
                      </span>
                      <br />
                      <span>
                        Você, segurado deve fornecer todas as informações
                        relacionadas ao risco do seu negócio e que possam afetar
                        o julgamento da seguradora na aceitação do risco, a
                        determinação do prêmio do seguro, as condições e
                        cláusulas da apólice; caso as referidas informações não
                        forem divulgadas, quando da ocorrência de sinistro a
                        Seguradora poderá anular indenizações desde o início de
                        sua vigência ou mesmo não acatar sinistros ocorridos, em
                        conformidade com o Artigo 766 do Código Civil.
                      </span>
                      <br />
                      <span>
                        Lembramos que este documento é confidencial e
                        terminantemente proibido sua divulgação parcial ou total
                        a terceiros sem a expressa autorização da Lockton.
                      </span>
                      <br />
                      <span>
                        A Lockton Brasil seguindo a política mundial do grupo,
                        possui um conjunto de princípios que compõem as bases do
                        relacionamento comercial com os nossos Clientes,
                        definindo em linhas gerais, nossos processos internos e
                        critérios de colocação de riscos e administração de
                        seguros.
                      </span>
                      <br />
                      <a
                        href="https://assets.ctfassets.net/zr7mmeciv2ps/9RpLWenXE5XIYMlDWLj4a/161675887e2432d997a90c3f59e40d79/Princ__pios_de_Relacionamento_Comercial_Fev_2023.pdf"
                        style="color: blue;"
                      >
                        Para saber mais CLIQUE AQUI.
                      </a>
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td
              colspan="12"
              style="min-width: 100%; font-size: 12px; padding-top: 10px"
            >
              <span>
                Data/hora emissão:
                {{ dataHoraEmissao }}
              </span>
            </td>
          </tr>
        </table>
      </div>
    </v-row>
  </div>
</template>

<script>
import {
  asNumberString,
  asIntergerString,
  formatHistoricDate,
} from "@/utils/formats.js";
import QuotationCostsCardCafezal from "./QuotationCostsCardCafezal.vue";
export default {
  components: {
    QuotationCostsCardCafezal,
  },
  data() {
    return {
      asNumberString,
      asIntergerString,
      formatHistoricDate,
      selectedCost: null,
      dataCard: [],
    };
  },
  created() {
    this.setSelectedCost();
  },
  computed: {
    dataHoraEmissao() {
      const custos = this.currentQuotation.custos_cafezal[0];
      let data;

      if (custos.criada_em === "0001-01-01T00:00:00Z") {
        data = this.currentQuotation.criada_em;
      } else {
        data = custos.criada_em;
      }

      return this.formatHistoricDate(data);
    },
    areaPlantadaTotal() {
      let sum = 0;

      this.currentQuotation.itens_cafezal.forEach(x => {
        sum += x.area_plantada;
      });
      return sum;
    },
    getComissao() {
      let comissao = '';
      if (this.selectedCost) {
        comissao = `é de ${ this.selectedCost[0].comissao } porcento`;
      } else {
        comissao = "será definida após a escolha da cotação";
      }
      return comissao;
    },
    getTotalPlantas() {
      return Math.round(this.currentQuotation.itens_cafezal.reduce((subTotal, item) => subTotal + (item.planta_hectare * item.area_plantada), 0));
    },
    itemsFiltrados() {
      if (this.isGranizo) {
        return this.dataCard.filter(item => item.granizo > 0);
      } else {
        return this.dataCard.filter(item => item.granizo_geada > 0);
      }
    },
    getCustosCard() {
      if (this.selectedCost != null) {
        return this.selectedCost;
      }
      if (!this.dataCard.length) {
        this.loadCosts();
      }
      return this.itemsFiltrados;
    }
  },
  methods: {
    getLogoGrupoEconomico() {
      return (
        this.currentQuotation.grupo_economico?.logo_url ??
        this.selectedCost.grupo_economico?.logo_url
      );
    },
    formatText(text) {
      if (text == null) {
        return "";
      }

      const lines = text.split("  ");
      const firstLine = `<span style="background-color: black; color: white; display: block;">${lines[0].toUpperCase()}</span>`;
      const remainingLines = lines.slice(1).filter(line => line.trim() !== "");
      const formattedText = [firstLine, ...remainingLines].join("  ");

      return formattedText;
    },
    getCustos() {
      if (this.selectedCost != null) {
        return this.selectedCost;
      }
      return this.currentQuotation.custos_cafezal;
    },
    getCardIndex(index) {
      let totalGranizo = this.dataCard.filter(item => item.granizo > 0).length;
      if (!this.isGranizo) {
        index = totalGranizo + index;
      }
      return index;
    },
    loadCosts() {
      let cards = [
        ...new Set(this.currentQuotation.custos_cafezal.map(x => x))
      ].map(x => {
        let cost_normal =
          this.currentQuotation.custos_cafezal
            .filter(
              d =>
                d.seguradora.id == x.seguradora.id &&
                d.area_segurada == x.area_segurada &&
                d.valor_planta == x.valor_planta &&
                d.granizo == x.granizo &&
                d.granizo_geada == x.granizo_geada &&
                d.perda_producao_futura == x.perda_producao_futura &&
                d.tratamento_fitossanitario == x.tratamento_fitossanitario &&
                d.tipo_pos.id == "normal"
            )
            .map(u => u)[0] ?? null;
        let cost_reduzida =
          this.currentQuotation.custos_cafezal
            .filter(
              d =>
                d.seguradora.id == x.seguradora.id &&
                d.area_segurada == x.area_segurada &&
                d.valor_planta == x.valor_planta &&
                d.granizo == x.granizo &&
                d.granizo_geada == x.granizo_geada &&
                d.perda_producao_futura == x.perda_producao_futura &&
                d.tratamento_fitossanitario == x.tratamento_fitossanitario &&
                d.tipo_pos.id == "reduzida"
            )
            .map(u => u)[0] ?? null;
        return {
          seguradora: x.seguradora,
          area_segurada: x.area_segurada,
          valor_planta: x.valor_planta,
          granizo_geada: x.granizo_geada,
          granizo: x.granizo,
          perda_producao_futura: x.perda_producao_futura,
          tratamento_fitossanitario: x.tratamento_fitossanitario,
          pos_reduzido: {
            id: cost_reduzida?.id ?? null,
            premio_total: cost_reduzida?.premio_total,
            subvencao_federal: cost_reduzida?.subvencao_federal,
            subvencao_estadual: cost_reduzida?.subvencao_estadual,
            investimento: cost_reduzida?.investimento,
            premio_segurado: cost_reduzida?.premio_segurado,
            paymentForm: cost_reduzida?.paymentForm
          },
          pos_normal: {
            id: cost_normal?.id ?? null,
            premio_total: cost_normal?.premio_total,
            subvencao_federal: cost_normal?.subvencao_federal,
            subvencao_estadual: cost_normal?.subvencao_estadual,
            investimento: cost_normal?.investimento,
            premio_segurado: cost_normal?.premio_segurado,
            paymentForm: cost_normal?.paymentForm
          }
        };
      });

      this.dataCard = [];
      cards.forEach(card => {
        if (
          this.dataCard.filter(
            x =>
              x.pos_normal?.id == card.pos_normal?.id &&
              x.pos_reduzido?.id == card.pos_reduzido?.id
          ).length == 0
        ) {
          this.dataCard.push(card);
        }
      });
    },
    setSelectedCost() {
      if (
        this.currentQuotation.custos_cafezal.some(a => a.aprovada_em != null)
      ) {
        this.selectedCost = this.currentQuotation.custos_cafezal.filter(
          a => a.aprovada_em != null
        );
        this.selectedCost.grupo_economico = this.currentQuotation.grupo_economico;
      }
    }
  },
  props: {
    currentQuotation: {
      type: Object
    },
    isTableView: {
      type: Boolean,
      default: true
    },
    isGranizo: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style>
.containerCardsCafezal {
  display: flex;
  flex-flow: row wrap;
  margin: 0;
  padding: 0;
}

@media print {
  .containerCardsCafezal {
    display: flex;
    flex-flow: row wrap;
    margin: 0 !important;
    margin-left: -20px !important;
    padding: 0px !important;
  }
}

@media print {
  .container_cardCafezal {
    margin: 0 !important;
  }
}

@media print {
  .card-wrapperCafezal {
    page-break-inside: avoid;
    padding-right: 0px;
  }
}
</style>
